import { render, staticRenderFns } from "./servicePackage.vue?vue&type=template&id=ffd13b0e&scoped=true"
import script from "./servicePackage.vue?vue&type=script&lang=js"
export * from "./servicePackage.vue?vue&type=script&lang=js"
import style0 from "./servicePackage.vue?vue&type=style&index=0&id=ffd13b0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd13b0e",
  null
  
)

export default component.exports